import { render, staticRenderFns } from "./academicCard.vue?vue&type=template&id=56d2a700"
import script from "./academicCard.vue?vue&type=script&lang=js"
export * from "./academicCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports